<template>
    <vl-map
        ref="map"
        :load-tiles-while-animating="true"
        :load-tiles-while-interacting="true"
        data-projection="EPSG:4326"
        style="height: 100vh"
        class="w-1/2 h-screen"
        :wrap-x="false"
    >
        <vl-view
            ref="view"
            :zoom.sync="zoom"
            :center.sync="mapCenter"
            :rotation.sync="rotation"
        ></vl-view>
        <vl-geoloc @update:position="geolocPosition = $event">
            <template slot-scope="geoloc">
                <vl-feature v-if="geoloc.position" id="position-feature">
                    <vl-geom-point :coordinates="geoloc.position"></vl-geom-point>
                    <vl-style-box>
                        <vl-style-icon
                            src="_media/marker.png"
                            :scale="0.4"
                            :anchor="[0.5, 1]"
                        ></vl-style-icon>
                    </vl-style-box>
                </vl-feature>
            </template>
        </vl-geoloc>
        <vl-layer-tile id="osm">
            <vl-source-osm :wrap-x="false"></vl-source-osm>
        </vl-layer-tile>
        <vl-feature v-for="(point, index) in mapPoints" :key="index" :properties="{ id: point[0] }">
            <vl-geom-point :coordinates="[point[1], point[2]]"></vl-geom-point>
            <vl-style-box>
                <vl-style-circle :radius="10">
                    <vl-style-fill color="blue"></vl-style-fill>
                    <vl-style-stroke color="blue"></vl-style-stroke>
                </vl-style-circle>
            </vl-style-box>
        </vl-feature>
        <!-- test -->
        <vl-interaction-select :features.sync="selectedFeatures">
            <template slot-scope="select">
                <!-- select styles -->
                <vl-style-box>
                    <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                    <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    <vl-style-circle :radius="5">
                        <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
                        <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
                    </vl-style-circle>
                </vl-style-box>
                <vl-style-box :z-index="1">
                    <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    <vl-style-circle :radius="5">
                        <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
                    </vl-style-circle>
                </vl-style-box>
                <!--// select styles -->

                <!-- selected feature popup -->
                <vl-overlay
                    class="feature-popup"
                    v-for="feature in select.features"
                    :key="feature.id"
                    :id="feature.id"
                    :position="pointOnSurface(feature.geometry)"
                    :auto-pan-animation="{ duration: 300 }"
                >
                    <template>
                        <EventCard
                            style="width: 16.5rem"
                            :event="events.filter(item => item.id.$t == feature.properties.id)[0]"
                        ></EventCard>
                    </template>
                </vl-overlay>
                <!--// selected popup -->
            </template>
        </vl-interaction-select>
        <!-- tset -->
    </vl-map>
</template>
<script>
import { findPointOnSurface } from 'vuelayers/lib/ol-ext'
import EventCard from './EventCard'
export default {
    name: 'Map',
    props: ['mapView', 'currentcenter', 'locations', 'events'],
    components: {
        EventCard,
    },
    data() {
        return {
            zoom: 12,
            center: this.currentcenter,
            rotation: 0,
            geolocPosition: undefined,
            selectedFeatures: [],
        }
    },
    methods: {
        pointOnSurface: findPointOnSurface,
    },
    computed: {
        mapCenter: function() {
            return this.currentcenter
        },
        mapPoints: function() {
            return this.locations
        },
    },
    watch: {
        mapView: function() {
            this.$refs.map.refresh()
            this.$refs.view.refresh()
            this.$refs.map.updateSize()
        },
        currentcenter: function() {
            this.$refs.map.refresh()
            this.$refs.map.updateSize()
        },
        locations: function() {
            this.$refs.map.refresh()
            this.$refs.map.updateSize()
        },
        mapPoints: function() {
            this.$refs.map.refresh()
            this.$refs.map.updateSize()
        },
    },
    created() {},
}
</script>
